import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { VideoService } from '@core/services/video.service';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TrackingService } from '@core/services/tracking.service';
import { extractNamesArray } from '@core/utils/helpers';

@Component({
	selector: 'kwo-video-item',
	templateUrl: './video-item.component.html',
	styleUrls: ['./video-item.component.scss'],
	standalone: true,
	imports: [CommonModule, SafeHtmlPipe, FaIconComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class VideoItemComponent implements OnInit {

	@Input() video: any;
	@Input() mode: string = '';
	@Input() useTransition: boolean = false;
	@Input() showEpisodes: boolean = false;

	private router = inject(Router);
	private videoService = inject(VideoService);
	private trackingService = inject(TrackingService);

	mouseDownTimestamp: number = 0;
	watchedList = this.videoService.watchedList;

	ngOnInit(): void {

		this.video.watched = this.watchedList().includes(this.video.video);
	}

	goToVideo(slug: string) {


		this.trackingService.track('Video Cover Click', {
			video_id: this.video.video,
			video_name: this.video.title,
			video_cover_image_url: this.video.cover,
			video_category: extractNamesArray(this.video.categories),
			video_creator: extractNamesArray(this.video.content_creators)
		});

		if (Date.now() - this.mouseDownTimestamp < 200) {

			this.router.navigate(['/video/', slug]);
		}
	}

	dragStart() {

		this.mouseDownTimestamp = Date.now();
	}
}